export default __webpack_public_path__ + "static/media/export.e3159e74.svg";